import {merge, omit} from 'lodash';
import {SHOW_TOOLTIP, HIDE_TOOLTIP, CHANGE_SECTION} from './actions';

const initialState = {
  section: 'color',
};

const aptitudeReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_SECTION:
      return {
        ...state,
        section: action.section,
      };
    default:
      return state;
  }
};

export function tooltipReducer(state = {}, action) {
  switch (action.type) {
    case SHOW_TOOLTIP:
      return merge({}, state, {[action.tooltipId]: true});
    case HIDE_TOOLTIP:
      return omit(state, action.tooltipId);
    default:
      return state;
  }
}

export default aptitudeReducer;
